// @flow

import * as React from "react";
import Modal from "react-modal";
import cx from "classnames";

import styles from "./ModalLauncher.scss";

export type ModalLauncherRenderProps = {
  open: () => void,
  close: () => void
};

type ModalLauncherProps = {
  trigger?: ModalLauncherRenderProps => React.Node,
  header?: () => React.Node,
  contentLabel?: string,
  wide: boolean,
  content: ModalLauncherRenderProps => React.Node,
  closeBtnVisible?: boolean,
  isOpen?: boolean,
  customOverlayStyles?: string,
  customContentStyles?: string
};

type ModalLauncherState = {
  isOpen: boolean
};

class ModalLauncher extends React.Component<ModalLauncherProps, ModalLauncherState> {
  state = {
    isOpen: false
  };

  static defaultProps = {
    content: () => null,
    contentLabel: "",
    customOverlayStyles: "",
    customContentStyles: "",
    wide: false,
    closeBtnVisible: true
  };

  componentDidMount() {
    const { isOpen } = this.props;
    Modal.setAppElement("#root");
    if (isOpen) {
      this.open();
    }
  }

  setIsOpen = (isOpen: boolean) => this.setState({ isOpen });

  open = () => this.setIsOpen(true);

  close = () => this.setIsOpen(false);

  getRenderProps = () => ({
    open: this.open,
    close: this.close
  });

  render() {
    const {
      trigger,
      header,
      content,
      contentLabel,
      wide,
      closeBtnVisible,
      customOverlayStyles,
      customContentStyles
    } = this.props;
    const { isOpen } = this.state;
    const renderProps = this.getRenderProps();

    return (
      <React.Fragment>
        {trigger && trigger(renderProps)}
        <Modal
          className={cx("content", customContentStyles, { [styles.wide]: wide })}
          overlayClassName={cx("overlay", customOverlayStyles)}
          isOpen={isOpen}
          onRequestClose={() => {
            if (closeBtnVisible) {
              this.close();
            }
          }}
          contentLabel={contentLabel}
          closeTimeoutMS={300}
          ariaHideApp={!process.env.NODE_ENV === "test"}
        >
          {header && <h1 className={styles.header}>{header()}</h1>}
          {content && content(renderProps)}
          {closeBtnVisible && (
            <button
              type="button"
              className={styles.close}
              onClick={this.close}
              data-testid="closeButton"
              aria-label="schließen"
            >
              &#215;
            </button>
          )}
        </Modal>
      </React.Fragment>
    );
  }
}

export default ModalLauncher;
